import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { FlashMessagesService } from 'ngx-flash-messages'; 
declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
   
export const ROUTES: RouteInfo[] = [
    { path: 'dashboard', title: 'Dashboard',  icon: 'pe-7s-graph', class: '' },
    { path: 'shop_profile', title: 'Shop Profile',  icon: 'pe-7s-user', class: '' },
    { path: 'shop_promocodes', title: 'Shop Promocodes',  icon: 'pe-7s-star', class: '' },
    { path: 'games', title: 'Challenges',  icon:'pe-7s-joy', class: '' },
    { path: 'shops', title: 'Shops',  icon:'pe-7s-shopbag', class: '' },
    { path: 'promocodes', title: 'Promo Codes',  icon:'pe-7s-star', class: '' },
    { path: 'users', title: 'Game Users',  icon:'pe-7s-users', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

    menuItems: any[];

    ShopAdmin:boolean;
    MallAdmin:boolean;
    GameAdmin:boolean;
  constructor(
    private authservice:AuthService, 
    private router:Router,
    private flashmsg:FlashMessagesService
   ) { }

  ngOnInit() {
    
    this.menuItems = ROUTES.filter(menuItem => menuItem);

  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
  onLogoutClick(){
    this.authservice.logoutUser();
    this.flashmsg.show('See You Soon !',
    {classes:['alert-success'], timeout:5000
   });
    this.router.navigate(['login'])
    return false
}
}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/sidebar/sidebar.component.ts